import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Ticket = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/linear/ticket">
        <g id="ticket">
          <path
            id="Vector"
            d="M12.9997 8.33317C12.9997 7.41317 13.7463 6.6665 14.6663 6.6665V5.99984C14.6663 3.33317 13.9997 2.6665 11.333 2.6665H4.66634C1.99967 2.6665 1.33301 3.33317 1.33301 5.99984V6.33317C2.25301 6.33317 2.99967 7.07984 2.99967 7.99984C2.99967 8.91984 2.25301 9.6665 1.33301 9.6665V9.99984C1.33301 12.6665 1.99967 13.3332 4.66634 13.3332H11.333C13.9997 13.3332 14.6663 12.6665 14.6663 9.99984C13.7463 9.99984 12.9997 9.25317 12.9997 8.33317Z"
            stroke="#383E43"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M6.66699 2.6665L6.66699 13.3332"
            stroke="#292D32"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="5 5"
          />
        </g>
      </g>
    </svg>
  );
};

Ticket.displayName = 'Ticket';
